<template>
    <new-modal ref="changeProviderLevelModal" title="Change Provider Level">
        <template #trigger>
            <slot />
        </template>
        <template #content>
            <div class="">
                Changing your provider level will reset ALL your progress. This
                will remove all quiz, flashcard, study guide worksheet, and
                video history, reset all goals and your study time.
            </div>
            <div class="font-bold">This cannot be undone. Are you sure?</div>

            <div class="my-8">
                <form class="form" @submit.prevent="submitForm">
                    <div class="w-full">
                        <div class="input-group">
                            <form-select
                                theme="dimmed"
                                label="Select new Provider Level"
                                name="provider_level"
                                :allow-null="false"
                                v-model="form.providerLevelId"
                                :options="providerLevelOptions"
                            />
                        </div>
                    </div>
                </form>
            </div>
        </template>
        <template #controls>
            <div class="flex w-full justify-end gap-4">
                <div class="btn btn-outline" @click="cancel">Cancel</div>
                <div
                    :class="
                        'btn' +
                        ' ' +
                        (form.isDirty ? ' btn-primary' : 'btn-disabled')
                    "
                    @click="changeProviderLevel"
                >
                    Yes, change my provider level
                </div>
            </div>
        </template>
    </new-modal>
    <div></div>
</template>

<script>
import FormSelect from "@/Components/FormSelect";
import NewModal from "@/Components/NewModal.vue";

export default {
    name: "StudentChangeProviderLevel",
    components: { NewModal, FormSelect },

    data() {
        return {
            form: this.$inertia.form({
                providerLevelId: this.$page.props.auth.user.provider_level_id,
            }),
        };
    },
    methods: {
        changeProviderLevel: function (e) {
            this.$inertia.get(
                route("student.account.change-provider-level", {
                    new_provider_level_id: this.form.providerLevelId,
                })
            );
        },
        cancel() {
            this.$refs.changeProviderLevelModal.closeModal();
        },
    },
    computed: {
        providerLevelOptions() {
            let providerLevelOptions = [];

            this.$page.props.providerLevels.forEach(function (providerLevel) {
                providerLevelOptions.push({
                    value: providerLevel.id,
                    label: providerLevel.title,
                });
            });

            return providerLevelOptions;
        },
    },
};
</script>
